import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GlobalIconComponent } from './global-icon/global-icon.component';

@NgModule({
    imports: [CommonModule],
    declarations: [GlobalIconComponent],
    exports: [GlobalIconComponent],
})
export class LibSvgIconsModule {}
